import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ResponseList } from 'models';
import { Employee } from 'models/user/Employee';

export type UseEmployeeInformationByEmployeeCodeProps = {
    enabled?: boolean;
    sid?: string;
    platformId?: string;
    employeeCode?: string;
};

export function useEmployeeInformationByEmployeeCode(
    props: UseEmployeeInformationByEmployeeCodeProps
) {
    const { enabled, sid, platformId, employeeCode } = props;

    return useQuery({
        enabled,
        queryKey: [
            'employee-information',
            { sid, platform_id: platformId, employee_code: employeeCode }
        ],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<Employee>>('/v1/f1/employee', {
                signal,
                params: {
                    sid,
                    platform_id: platformId,
                    employee_code: employeeCode
                }
            }),
        select: response =>
            response.data.result_list?.length > 0 ? response.data.result_list[0] : undefined,
        retry: 1
    });
}
